import styled from "styled-components";
import Variables from "../../assets/styleVariables";

const TYPES = {
  primary: {
    background: Variables.colors.primary_100,
    text: Variables.colors.primary_dark
  },
  warning: {
    background: Variables.colors.deep_orange_lighten_5,
    text: Variables.colors.deep_orange_darken_3
  },
  danger: {
    background: Variables.colors.red_50,
    text: Variables.colors.red_500
  },
  success: {
    background: Variables.colors.green_100,
    text: Variables.colors.green
  },
  owner: {
    background: Variables.colors.green_lighten_5,
    text: Variables.colors.green_darken_3
  },
  admin: {
    background: Variables.colors.purple_lighten_5,
    text: Variables.colors.purple_darken_3
  },
  manager: {
    background: Variables.colors.blue_lighten_5,
    text: Variables.colors.blue_darken_3
  },
  custodian: {
    background: Variables.colors.blue_grey_lighten_5,
    text: Variables.colors.blue_grey_darken_3
  },
  pending: {
    background: Variables.colors.blue_lighten_5,
    text: Variables.colors.blue_darken_3
  },
  disable: {
    background: Variables.colors.blue_grey_lighten_5,
    text: Variables.colors.blue_grey_darken_3
  }
};
export const Box = styled.div`
  width: fit-content;
  display: flex;
  border: none;
  border-radius: 18px;
  padding: 6px 16px 6px 16px;
  text-decoration: none;
  background-color: ${props =>
    props.color
      ? TYPES[props.color].background
      : TYPES["primary"].background} !important;
  color: ${props =>
    props.color ? TYPES[props.color].text : TYPES["primary"].text};
  font-size: ${props =>
    props.size === "extra_small"
      ? Variables.font_sizes.x_small
      : props.size === "small"
      ? Variables.font_sizes.x_medium
      : Variables.font_sizes.large};
`;
